import { render, staticRenderFns } from "./FrzTransferPallet.vue?vue&type=template&id=65218c18"
import script from "./FrzTransferPallet.vue?vue&type=script&lang=js"
export * from "./FrzTransferPallet.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports